import { Pipe, PipeTransform } from '@angular/core';
import linkifyHtml from 'linkify-html';
import * as linkify from 'linkifyjs';

const DEFAULT_OPTIONS: linkify.Opts = {
  defaultProtocol: 'https',
  target: '_blank',
  validate: {
    url: (value: string) => /^(https?:\/\/|www\.)/i.test(value),
  },
};

@Pipe({
  name: 'linkify',
  standalone: false,
})
export class LinkifyPipe implements PipeTransform {
  public transform(html?: any): string {
    return typeof html === 'string' && html ? linkifyHtml(html, DEFAULT_OPTIONS) : '';
  }
}
